import { render, staticRenderFns } from "./IconReturn.vue?vue&type=template&id=13b7710c&scoped=true"
import script from "./IconReturn.vue?vue&type=script&lang=js"
export * from "./IconReturn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b7710c",
  null
  
)

export default component.exports